import React, { useEffect, useMemo, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useTour } from '@reactour/tour';
import { buildAfterScanSteps, buildAfterSubmitSteps, openTour, waitForEls } from './../common/app-tour-guide';
import PopQuestion from './pop-question';
import '../../App.css';
import AppBar from '@mui/material/AppBar';
import { EssayHelper } from "../../helpers/essay.helper";
import { COUNTRY_OPTIONS } from '../../constants/countries';
import ScanPopup from './scan-popup';
import ScanCam from './scan-cam';
import {
  Avatar, Button, Box, Card, CircularProgress, FormControl, Grid, IconButton, Input, InputLabel,
  Menu, MenuItem,
  Select, Snackbar, Stack, Switch, TextField, Tooltip, Typography, FormControlLabel, Checkbox,
  imageListClasses, useMediaQuery
} from '@mui/material';
import { styled } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from '@mui/icons-material/Close';
import { useUser } from '../../UserContext';
import { AppHelper } from '../../AppHelper';
import './essay-form.css';
import PopScanAgain from "./pop-scan-again";
import EssayViewQuestion from './essay-view-question';
import EssaySubmitStatus from "./essay-submit-status"; 
import { Engineering } from "@mui/icons-material";
//import Typewriter from 'typewriter-effect/dist/core';
const configJson = require('../../config.json');
const dayjs = require('dayjs');

const useTypewriter = (text, speed = 70) => {
  const [displayText, setDisplayText] = useState('');

  useEffect(() => {
    let i = 0;
    const typingInterval = setInterval(() => {
      if (i < text.length) {
        setDisplayText(prevText => prevText.replace(/\|$/, '') + text.charAt(i) + '|');
        i++;
      } else {
        clearInterval(typingInterval);
      }
    }, speed);

    return () => {
      clearInterval(typingInterval);
    };
  }, [text, speed]);

  return displayText;
};
function Typewriter(props) {
  const { text, speed } = props;
  const displayText = useTypewriter(text, speed);

  const handleClick = () => {
    if (props.onClick) props.onClick();
  };
  return <div onClick={handleClick}
    style={{
      color: '#999',
      fontSize: '1.3rem', fontFamily: "'Playpen Sans', cursive", lineHeight: '35px',
      background: 'linear-gradient(to bottom, white 34px, #00b0d7 1px)', backgroundSize: '100% 35px',
      minHeight: '25rem',
      direction: 'ltr',
      width: '100%', textAlign: 'left', padding: '0', border: 'none', outline: 'none', overflow: 'auto',
    }}
  >{displayText}</div>;
}
const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#1890ff',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));

export default function EssayFormV2(props) {
  const { 
    profileGrade, 
    drawerWidth, 
    isClosing, 
    viewMode, 
    essayFormDone, 
    profileId, 
    essayId, 
    onDeleteDraft, 
    parentEssay, 
    grade,
    gradeList
   } = props;
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [isPopupQuestionOpen, setPopupQuestionOpen] = useState(false);
  const [questionId, setQuestionId] = React.useState('');
  const [isScanCamOpen, setIsScanCamOpen] = useState(false);
  const navigate = useNavigate();
  const [authOK, setAuthOK] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [oUser, setOUser] = React.useState(null);
  const [isCropped, setIsCropped] = useState(false);
  const [title, setTitle] = React.useState('');
  const [msgText, setMsgText] = React.useState('');
  const [msgTextOld, setMsgTextOld] = React.useState('');
  const [msgText2, setMsgText2] = React.useState('');
  const [isEdit, setIsEdit] = React.useState(false);
  const [cursorPosition, setCursorPosition] = useState(0);
  const txtName = useRef(null);
  const [txtNameOK, setTxtNameOK] = useState(true);
  const [essayTitle, setEssayTitle] = React.useState('');
  const [vMode, setVMode] = React.useState('NEW');
  const [charCount, setCharCount] = React.useState(0);
  // const [gradeOK, setGradeOK] = useState(true);
  const [version, setVersion] = useState('4.0');
  const [versionCorr, setVersionCorr] = useState('2.0');
  const [startProcessing, setStartProcessing] = useState(false);
  
  const [imgs, setImgs] = useState([]);

  const [doneEval, setDoneEval] = React.useState(false);
  const [doneCorrect, setDoneCorrect] = React.useState(false);
  const [evalStatus, setEvalStatus] = React.useState('Grammar');
  const [evalStatusP, setEvalStatusP] = React.useState(0);
  const [isSa, setIsSa] = React.useState(false);
  const [evalStatusSP, setEvalStatusSP] = React.useState({ done: false, v: 50 });
  const [evalStatusCT, setEvalStatusCT] = React.useState({ done: false, v: 50 });
  const [evalStatusCR, setEvalStatusCR] = React.useState({ done: false, v: 50 });
  const [evalStatusGM, setEvalStatusGM] = React.useState({ done: false, v: 50 });
  const [evalStatusVC, setEvalStatusVC] = React.useState({ done: false, v: 50 });
  const [evalStatusST, setEvalStatusST] = React.useState({ done: false, v: 50 });
  const [savingDraft, setSavingDraft] = React.useState(false);
  const [draftId, setDraftId] = React.useState('');
  const [newEssayId, setNewEssayId] = React.useState('');
  const [titlePlaceHolder, setTitlePlaceHolder] = React.useState('TITLE');
  const [titleError, setTitleError] = React.useState(false);
  const [bodyPlaceHolder, setBodyPlaceHolder] = React.useState('');
  //const [timerSaveDraft, setTimerSaveDraft] = useState(null);
  const [questionList, setQuestionList] = useState([]);
  const [question, setQuestion] = React.useState({});
  const [questionPopShow, setQuestionPopShow] = React.useState(false);
  const timerSaveDraft = useRef(null);
  const gradeList0 = [
    // { v: 'P1', n: 'PRIMARY 1'},
    // { v: 'P2', n: 'PRIMARY 2'},
    // { v: 'P3', n: 'PRIMARY 3'},
    { v: 'P4', n: 'PRIMARY 4', wMin: 120 },
    { v: 'P5', n: 'PRIMARY 5', wMin: 150 },
    { v: 'P6', n: 'PRIMARY 6', wMin: 150 }
  ];
  const verList = [
    { v: '1', n: 'Score 1.0' },
    { v: '2', n: 'Score 2.0' },
    { v: '2.1', n: 'Score 2.1' },
    { v: '2.2', n: 'Score 2.2' },
    { v: '3.0', n: 'Score 3.0' },
    { v: '3.1', n: 'Score 3.1' },
    { v: '4.0', n: 'Score 4.0' },
  ];
  const verListCorr = [
    { v: '1.0', n: 'Correction 1.0' },
    { v: '2.0', n: 'Correction 2.0' },
  ];

  const [formValid, setFormValid] = useState(true);
  const [formMsgError, setFormMsgError] = useState('');
  const [bodyRows, setBodyRows] = useState(10);
  const refPopScan = useRef(null);
  const [showTypewriter, setShowTypewriter] = useState(false);
  const [scanAgain, setScanAgain] = useState(false);
  const [isEnhancedTranscription, setIsEnhancedTranscription] = useState(false);
  const [scanAgainStart, setScanAgainStart] = useState(false);
  const [scanComplete, setScanComplete] = useState(false);
  const [useEnhanced, setUseEnhanced] = useState(false);
  const [maxWordCount, setMaxWordCount] = useState();
  const [submitOverride, setSubmitOverride] = useState(false);
  // const [highlight, setHighlight] = useState(false);  
  const { setIsOpen: tourOpen, setSteps: tourSetSteps, setCurrentStep: tourSetCurrent } = useTour();

  const isMobile = useMediaQuery('(max-width:540px)'); // Detect small screens

  var timerTypewriter = null;
  useEffect(() => {
    if (txtName.current.value.length < 1) {
      if (titlePlaceHolder == 'TITLE') {
        if (timerTypewriter) clearTimeout(timerTypewriter);
        timerTypewriter = setTimeout(() => {
          typewriterStart();
        }, 1000 * 3);
      }
      else {
        if (timerTypewriter) clearTimeout(timerTypewriter);
        timerTypewriter = setTimeout(() => {
          typewriterStart();
        }, 1000 * 0.1);
      }
    }
    else {
      setTitlePlaceHolder('TITLE');
      setBodyPlaceHolder('');
    }
  }, [titlePlaceHolder, bodyPlaceHolder, txtName]);
  
  useEffect(()=>{
    if(!parentEssay || !parentEssay.essayId) return;
    // txtName.current.value = parentEssay.topic;
    // setMsgText(parentEssay.text);
    if(parentEssay.question){
      setQuestion(parentEssay.question);
      setQuestionId(parentEssay.question.questionId);
      setQuestionPopShow(true);
    }
  }, [parentEssay])
  
  useEffect(() => {
    if (isPopupOpen) {
      // txtName.current.value = ""; // Reset the value of txtName input field
    }
  }, [isPopupOpen]);

  useEffect(() => {
    console.log("QUESTION", parentEssay);
    if (!essayId) {
      //if(!parentEssay)
      {
        setDraftId('');
        if (!parentEssay || !parentEssay.essayId){
          setQuestion({});
          setQuestionId('');
        }
        if (txtName && txtName.current) {
          txtName.current.value = "";
        }
        setMsgText("");
        setMsgText2("");
        setCharCount(0);
        //setQuestion(null);
        // setQuestionId(null);
      }
      return;
    }
    setQuestion({});
    var _user = AppHelper.userCacheGet();
    AppHelper.apiPost('api/essay/detail', { token: _user.token, essayId: essayId }).then(_res => {
      if (_res && _res.status) {
        setDraftId(essayId);
        if (txtName && txtName.current) {
          txtName.current.value = _res.data.topic;
          setMsgText(_res.text.replace(/\n/g, "<br/>").replace(/Page Break/g, "<div style='color:white;background-color:blue;display:inline-block'>Page Break</div>"));
          setMsgText2(_res.text.replace(/\n/g, "<br/>").replace(/Page Break/g, "<div style='color:white;background-color:blue;display:inline-block'>Page Break</div>"));
		  const words = _res.text.trim().split(/\s+/);
		
		  setCharCount(words.length);
      if (_res.data.questionId.length > 0) {
        setQuestion(_res.question);
        setQuestionId(_res.question.questionId);
        // findQuestion(_res.data.questionId);
      }
        }
      }
    });
  }, [essayId, parentEssay]);

  useEffect(() => {
    var _user = AppHelper.userCacheGet();
    setAuthOK(_user != null);
    setOUser(_user);
    console.log("oUser", _user);
  }, [profileGrade]);

  useEffect(() => {
    if (!gradeList || gradeList.length === 0 || !grade) return;
    const g = gradeList.find(item => item.v === grade);
    if (g) {
      setMaxWordCount(g.maxW);
    }
  }, [gradeList, grade]);

  useEffect(() => {
    if (props.viewMode)
      setVMode(props.viewMode);
  }, [props.viewMode]);
  useEffect(() => {
    setIsSa(props.isSa);
    txtName.current.focus();
  }, [props.isSa]);
  useEffect(() => {
    return () => {
      if (timerSaveDraft.current) {
        clearTimeout(timerSaveDraft.current);
        onSaveDraft();
      }
    };
  }, []);

  const handleClearQuestion = () => {
    setQuestion({ questionId: null });
    setQuestionId(-1); 
    setQuestionPopShow(true);
  }
  
  const selectedCountryOption = useMemo(() => {
    const fallback =
      COUNTRY_OPTIONS.find(c => c.name === "Singapore") || COUNTRY_OPTIONS[0];

    const v = oUser?.countryCode;
    if (!v) { return fallback; }
    const byName = COUNTRY_OPTIONS.find(c => c.name === v);
    if (byName) { return byName; }
    const byCode = COUNTRY_OPTIONS.find(c => (c.code || c.value) === v);
    return byCode || fallback;
  }, [oUser?.countryCode]);

  const localeLabel = (locale) => {
    const l = String(locale || "").toLowerCase().trim();
    if (!l) return "UK English";
    if (l.includes("uk")) { return "UK English" };
    if (l.includes("us")) { return "US English" };
    return locale;
  };
  const localeFlag = (locale) => {
    const l = String(locale || "").toLowerCase().trim();
    if (!l) return "UK English";
    if (l.includes("uk")) { return "🇬🇧" };
    if (l.includes("us")) { return "🇺🇸" };
    return locale;
  };

  const typewriterStart = () => {
    if (titlePlaceHolder == 'TITLE') {
      setTitlePlaceHolder('');
    }
    else {
      var _title = "Sammy's Quest for the Golden Acorn";
      if (titlePlaceHolder != _title) {
        var _titleNow = _title.substring(0, titlePlaceHolder.length + 1);
        setTitlePlaceHolder(_titleNow);
      }
      else {
        var _body = "Once upon a time in a beautiful green park, there lived a small, friendly squirrel named Sammy. Sammy loved playing hide and seek with his friends, but he had a big dream. He wanted to find the Golden Acorn, a legendary nut said to be hidden somewhere in the park. Every day, Sammy would go on an adventure, looking under leaves and climbing tall trees, hoping to find the acorn. One sunny day, while searching near the old oak tree, Sammy met a wise old owl. The owl told Sammy that the Golden Acorn was not just a nut, but a symbol of bravery and determination. Encouraged by the owl's words, Sammy didn't give up. He continued his search with even more enthusiasm. Finally, after many days of looking, Sammy found the Golden Acorn. It was more beautiful than he had imagined. But the most important thing he found was not the acorn, but the courage and persistence he had within himself all along. Sammy learned that with determination and a positive attitude, you can achieve your dreams. And that was the greatest treasure of all.";
        if (bodyPlaceHolder.length < _body.length) {
          var _bodyNow = _body.substring(0, bodyPlaceHolder.length + 1);
          setBodyPlaceHolder(_bodyNow);
        }
      }
    }
  }

  const msgTextChange = (arg) => {
    //setMsgBox(arg.target.value);
    var _txt = arg.target.value;
    setMsgText(_txt);
    const words = _txt.trim().split(/\s+/);
    setCharCount(words.length);

    const textareaLineHeight = 35;
    const previousRows = arg.target.rows;
    const currentRows = Math.ceil(arg.target.scrollHeight / textareaLineHeight);
    arg.target.rows = currentRows;
    if (currentRows !== previousRows) {
      setBodyRows(currentRows);
    }
  };

  const divRef = useRef(null);

  const msgTextChangeV2 = () => {
    const _txt = divRef.current.innerText.trim();
    // setMsgText(_txt);
    setMsgText2(_txt);
    const words = _txt.trim().split(/\s+/);
    setCharCount(words.length);
    if (words.length > 0)
      saveDraft();
  };

  const msgTextPaste = (event) => {
  };

  const saveDraft = () => {
    if (timerSaveDraft) {
      clearTimeout(timerSaveDraft.current);
    }
    timerSaveDraft.current = setTimeout(() => {
      onSaveDraft();
    }, 1000 * 1);
  };
  const onSaveDraft = async () => {
    //if(1==1) return;
    if (!txtName || !txtName.current) return;
    if (savingDraft) {
      saveDraft();
      return;
    }
    //if(1==1) return;
    var _topic = txtName.current.value;
    if (!_topic || _topic.length < 1) {
      _topic = '';
    }
    var _grade = gradeList.find(g => g.v == grade);
    if (!_grade) {
      setFormMsgError('Please select Grade.');
      setFormValid(false);
      return;
    }
	
    const currentText = divRef.current?.innerText || '';
    let _msgText = currentText; // .replace(/<div style='color:white;background-color:blue;display:inline-block'>Page Break<\/div>/g, "");
    // var _msgText = msgText2;
    // _msgText = _msgText.replace(/<div style='color:white;background-color:blue;display:inline-block'>Page Break<\/div>/g, "");
    //_msgText = _msgText.replace(/<span style="color:#7486ec;background-color: yellow">(.*?)<\/span>/g, '$1');
    _msgText = _msgText.replace(/<[^>]*>/g, "");
    _msgText = _msgText.replace(/“/g, '"');
    _msgText = _msgText.replace(/”/g, '"');
	  // _msgText = _msgText.replace(/\bPage Break\b/g, '');
    _msgText = _msgText.replace(/‘/g, "'");
    _msgText = _msgText.replace(/’/g, "'");	
    _msgText = _msgText.replace(/\n\n\n/gi, "\n\n");
    _msgText = _msgText.replace(/,(?!\s)/g, ', '); //-- add space behind comma if there is not.
    // _msgText = _msgText.replace(/\s{2,}/g, ' '); //-- remove space when multiple continuous spaces. (Unnecessary Space)
    _msgText = _msgText.replace(/\s*,/g, ','); //-- replace the space before comma if any. (Unnecessary Space)
    var _url = 'api/essay/create/draft';
    // if(version == '2') _url += '/v2';
    // else if(version == '2.1') _url += '/v2.1/';
    // else if(version == '2.2') _url += '/v2.2/';
    _url = 'api/essay/create/draft';
    var _payload = {
      token: oUser.token, imgs: imgs, topic: _topic, grade: grade, addScore: 0, text: _msgText, profileId: profileId, questionId: questionId, 
      verScore: 'v' + version,
      verCorr: 'v' + versionCorr
    };
    if (draftId && draftId.length > 0)
      _payload.essayId = draftId;
    setSavingDraft(true);
    var _res = await AppHelper.apiPost(_url, _payload);
    setSavingDraft(false);
    if (!_res || !_res.status) {
      return;
    }
    setDraftId(_res.data.essayId);
    var _resEssay = _res.data;
  }

  const essayStatusCheckDone = ({ code, essayId }) => {
    if (code === 'NEW') {
      if (typeof essayFormDone === 'function') {
        essayFormDone({ code, essayId });
      }
    }
  };
    
  const checkEssayStatus = async (argEssayId) => {
    var _res = await AppHelper.apiPost('api/essay/detail', { token: oUser.token, essayId: argEssayId });
    if (!_res || !_res.status) {
      alert('ERROR: Failed to load!');
      return;
    }
    checkEssayEvalStatus(_res.data.remark);
    if (_res.data.status == 8) {  //-- ERROR in EVAL or CORR
      alert('Submission failed. Please try again!');
      // setVMode('NEW');
      setTimeout(() => {
        checkEssayStatus(argEssayId);
      }, 3000);
      return;
    }
    if (_res.data.status != 5) {
      if (_res.data.status == 3) {setDoneEval(true);}
      if (_res.data.status == 4) {setDoneCorrect(true);}

      setTimeout(() => {
        checkEssayStatus(argEssayId);
      }, 3000);
      return;
    }
    
    if (_res.data.status === 5) {
      setTimeout(() => {
        waitForEls(['#improve-essay-btn', '#try-again-btn', '#report-card-btn', '#share-btn'], 5000, 200)
          .finally(() => {
            openTour(
              { setSteps: tourSetSteps, setCurrent: tourSetCurrent, setIsOpen: tourOpen },
              buildAfterSubmitSteps()
            );
          });
      }, 1000);

      setTimeout(() => {
        if (essayStatusCheckDone) {
          essayStatusCheckDone({
            code: 'NEW', 
            essayId: argEssayId,
            essayData: _res.data
          });
        } else if (essayFormDone) {
          essayFormDone({
            code: 'NEW', 
            essayId: argEssayId,
            essayData: _res.data
          });
        }
      }, 10000);
      return;
    }
  };
  
  const checkEssayEvalStatus = (argStatus) => {
    if (!argStatus || argStatus.length < 6) return;
	if (argStatus.charAt(6) == '1') setEvalStatusCT({ done: true, v: 100 });
	if (argStatus.charAt(5) == '1') setEvalStatusCR({ done: true, v: 100 });
    if (argStatus.charAt(4) == '1') setEvalStatusSP({ done: true, v: 100 });
    if (argStatus.charAt(3) == '1') setEvalStatusGM({ done: true, v: 100 });
    if (argStatus.charAt(2) == '1') setEvalStatusVC({ done: true, v: 100 });
    if (argStatus.charAt(1) == '1') setEvalStatusST({ done: true, v: 100 });
    if (argStatus.charAt(0) == '1') setDoneCorrect(true);
  }
  const handleClosePopup = () => {
    setPopupOpen(false);
  };
  const onScan = async () => {
    setPopupOpen(true);
    setUseEnhanced(false);
    setMsgTextOld('');
  };
  const onScanAgain = async () => {
    //setPopupOpen(true);
    setScanAgain(true);
    setScanAgainStart(false);
  };
  const onScanAgainCancel = async () => {
    setScanAgain(false);
  };
  const onScanAgainStart = async () => {
    setMsgTextOld(msgText);
    setScanAgainStart(true);
    setUseEnhanced(true);
  };
  const onUseEnhancedChange = (event) => {
    var _useEnhanced = event.target.checked
    setUseEnhanced(_useEnhanced);
    var _msgText = msgText;
    var _msgTextOld = msgTextOld;
    setMsgText(_msgTextOld);
    setMsgTextOld(_msgText);
  };
  const onDiscard = async () => {
    if (!window.confirm('Are you sure you want to discard the draft essay?')) return;
    var _payload = { token: oUser.token, essayId: draftId };
    var _url = 'api/essay/remove';
    var _res = await AppHelper.apiPost(_url, _payload);
    if (!_res || !_res.status) {
      alert("Fail to discard draft");
      return;
    }
    txtName.current.value = "";
    setMsgText('');
    setMsgText2('');
    if (divRef.current) {
      divRef.current.innerText = '';
    }
    setQuestion({});
    setQuestionId('');
    setQuestionPopShow(false);
    setCharCount(0);
    setScanComplete(false);
    setImgs([]);
    onDeleteDraft(draftId);
    setDraftId(null);
  };

  // const maxWordCount = 750; 
  const onSubmit = async () => {
    checkTitle();
    var _topic = txtName.current.value;
    if (!_topic || _topic.length < 1) {
      setTitleError(true);
      // setFormMsgError(`Please enter the Essay Title.`);
      setFormValid(false);
      setSubmitOverride(false); // Submit button will show as "Submit"
      return;
    }
    if (_topic.toLowerCase().includes('transcription') && !submitOverride) {
      setTitleError(true);
      setFormValid(false);
      setSubmitOverride(true);   // Submit button will show as "Submit Anyway" after first click
      return;
    }

    var _grade = gradeList.find(g => g.v == grade);
    if (!_grade) {
      setFormMsgError('Please select Grade.');
      setFormValid(false);
      return;
    }
    if (charCount < _grade.minW) {
      setFormMsgError(`Please submit an essay with a minimum of ${_grade.minW} words to evaluate at a ${_grade.n} level.`);
      setFormValid(false);
      return;
    }
    if (charCount > _grade.maxW) {
      setFormMsgError(`Submission limited to ${_grade.maxW} words for ${_grade.n} level. Please review and adjust as necessary.`);
	    setFormValid(false);
      return;
    }
	
    if(!questionPopShow && !question)
    {
      if(!parentEssay || !parentEssay.essayId)
      {
        setPopupQuestionOpen(true);
        setQuestionPopShow(true);
        return;
      }
    }
	
    setDoneEval(false);
    setDoneCorrect(false);
    var _msgText = msgText2;
    //_msgText = _msgText.replace(/<span style="color:#7486ec;background-color: yellow">(.*?)<\/span>/g, '$1');
	
    _msgText = _msgText.replace(/<div style='color:white;background-color:blue;display:inline-block'>Page Break<\/div>/g, "");
    _msgText = _msgText.replace(/<br\/>/g, '<br/>\n');
    _msgText = _msgText.replace(/<[^>]*>/g, "");
    _msgText = _msgText.replace(/“/g, '"');
	  _msgText = _msgText.replace(/\bPage Break\b/g, '');
    _msgText = _msgText.replace(/”/g, '"');
    _msgText = _msgText.replace(/‘/g, "'");
    _msgText = _msgText.replace(/’/g, "'");
    _msgText = _msgText.replace(/\n\n\n/gi, "\n\n");
    _msgText = _msgText.replace(/,(?!\s)/g, ', '); //-- add space behind comma if there is not.
    _msgText = _msgText.replace(/(\.\.|\.(?!\s))/g, (match) => match === '..' ? match : '. '); //-- add space behind . if there is not.
    //_msgText = _msgText.replace(/\s{2,}/g, ' '); //-- remove space when multiple continuous spaces. (Unnecessary Space)
    _msgText = _msgText.replace(/ {2,}/g, ' '); //-- remove space when multiple continuous spaces. (Unnecessary Space) - keep the new line char
    _msgText = _msgText.replace(/\s*,/g, ','); //-- replace the space before comma if any. (Unnecessary Space)

    var _url = 'api/essay/create';
    if (version == '2') _url += '/v2';
    else if (version == '2.1') _url += '/v2.1/';
    else if (version == '2.2') _url += '/v2.2/';
    _url = 'api/essay/create/withVersion/async';
    var _question = {};
    if(question && question.questionId){
      _question = {
        questionId: question.questionId,
        transcribe: question.transcribe,
        title: question.title,
        topic: question.topic,
      }
    }

    var _payload = { token: oUser.token, question:_question, questionId: questionId, imgs: imgs, topic: _topic, grade: grade, addScore: 0, text: _msgText, profileId: profileId };
    if (draftId) {
      _payload = { token: oUser.token, question:_question, questionId: questionId, imgs: imgs, topic: _topic, grade: grade, addScore: 0, text: _msgText, profileId: profileId, essayId: draftId };
    }
    if(parentEssay && parentEssay.essayId)
      _payload.parentId = parentEssay.essayId;

    if(!parentEssay)
	{
		if (version === "4.0") {
		_payload.questionId = questionId==-1?'':questionId; // Add questionId if version is 4.0
		}
	}
	else
	{
		_payload.questionId = parentEssay.question?.questionId==null?'':parentEssay.question.questionId;
	}

    _payload.verScore = 'v' + version;
    _payload.verCorr = 'v' + versionCorr;
    // if(1==1){
    //   setFormMsgError('TEST');
    //   return;
    // }
    setVMode('PROCESSING');
    checkEssayEvalStatus('');
    var _res = await AppHelper.apiPost(_url, _payload);
    var _resEssay = _res.data;
    if (!_res || !_res.status) {
      alert('ERROR: Failed to create!');
      setVMode('NEW');
      setEssayTitle(_topic);
      return;
    }
    else {
      //alert('Submitted!');
      if (essayFormDone) {
        setVMode('PROCESSING');
        checkEssayStatus(_resEssay.essayId);
        setNewEssayId(_resEssay.essayId);
        setStartProcessing(true);
        //essayFormDone(_res);
      }
    }
    setSubmitOverride(false);
  };

  const validateTitle = () => {
    if (!txtName.current) return; // Early return if the ref is not attached
  
    // setHighlight(false);
    if (title !== "" && title !== "Untitled") {
      if (title.toLowerCase().includes('transcription')) {
        if (question.title) {
          txtName.current.value = question.title;
        } else {
          txtName.current.value = title;
          txtName.current.scrollIntoView({ block: 'center' });
          txtName.current.select();
          setTitleError(true);
        }
      } else {
        txtName.current.value = title;
      }
      txtName.current.focus();
    }
  }
  
  // Check and add title for transcript image
  useEffect(() => {
    
    validateTitle();
  }, [title, question, txtName.current, txtName]);

  const handleScanComplete = (result, imgs, argIsEnhancedTranscription) => {
    setIsEnhancedTranscription(argIsEnhancedTranscription);
    var fullBody = "";
    result.data.forEach(item => {
      const { title, body } = item;
      // remove html tag
      var formattedBody = body.replace(/<[^>]*>/g, '');
      if (txtName.current.value == '') {
        setTitle(title);
      } 

      formattedBody = formattedBody.replace(/\[(.*?)\]/g, '<span style="color:#7486ec;background-color: yellow">$1</span>');

      const lastChar = formattedBody.trim().slice(-1);
      const isFullStop = lastChar === ".";


      if (isFullStop) {
        // formattedBody = formattedBody.replace(/\n/g, '<br/>');
         fullBody += formattedBody;
        fullBody += "<div style='color:white;background-color:blue;display:inline-block'>Page Break</div>";
      } else {
        fullBody += formattedBody.trim(-1);
        fullBody += ' '; // To add in a space if the next page's content is continued
        fullBody += "<div style='color:white;background-color:blue;display:inline-block'>Page Break</div>";
      }
      // fullBody += "<div style='color:white;background-color:blue;display:inline-block'>Page Break</div>";
    });
    fullBody = fullBody.replace(/<br\/>/g, '<br/>\n');
    fullBody = fullBody.replace(/\n/g, '<br/>');
    fullBody = fullBody.replace(/^<br\/>/, '');
    fullBody = fullBody.replace(/<div style='color:white;background-color:blue;display:inline-block'>Page Break<\/div>$/, '');
    const words = fullBody.trim().split(/\s+/);
    setCharCount(words.length);
    setImgs(imgs);
    setMsgText2(fullBody);
    setMsgText(fullBody);
    setScanComplete(true);
    setScanAgain(false);
    setTimeout(() => {
      openTour({ setSteps: tourSetSteps, setCurrent: tourSetCurrent, setIsOpen: tourOpen },
        buildAfterScanSteps());
    }, 250);
  };

  const onCamOpen = () => {
    setIsScanCamOpen(true);
  }
  const onCamClose = () => {
    setIsScanCamOpen(false);
  }
  const onCamCapture = (arg) => {
    setIsScanCamOpen(false);
    refPopScan.current.handleCamCapture(arg);
  }
  const typewirterClick = () => {
    setShowTypewriter(false);
  }
  const handleOpenQuestionDialog = () => {
    setPopupQuestionOpen(true);
	  setQuestionPopShow(true);
  }
  const popQuestionSubmit = (argQuestion)=>{ 
    if(!argQuestion || argQuestion == -1){
      onSubmit();
      setPopupQuestionOpen(false);
      return;
    }
	  
    const transformedQuestions = {
      ...argQuestion,
      images:argQuestion.imagePath, 
      imageCount: argQuestion.images
    }
    setQuestion(transformedQuestions);
    setQuestionId(transformedQuestions.questionId);
    setPopupQuestionOpen(false);
  }
  const popQuestionClose = (questionId) => {
    setQuestionId((questionId || questionId==-1) || '');
    setPopupQuestionOpen(false);
  }

  const checkTitle = () => {
    if (!txtName.current) { return; }
    saveDraft();
    if (txtName.current.value.trim() !== '') {
      // setHighlight(false);
      setTitle(txtName.current.value);
      setTitleError(false);
    } else {
      txtName.current.focus();
      txtName.current.select();
      // setHighlight(true);
    }
    
    const t = (txtName.current.value || '').trim().toLowerCase();
    if (!t || !t.includes('transcription')) {
      setSubmitOverride(false);
    }
  }

  const LocaleCapsule = oUser ? (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1,
        px: 1.25,
        py: 0.5,
        borderRadius: "999px",
        border: "1px solid rgba(0,0,0,0.12)",
        backgroundColor: "rgba(255,255,255,0.9)",
        cursor: "pointer",
        whiteSpace: "nowrap",
        flexShrink: 0,
      }}
      onClick={() => navigate("/profile")}
    >
      <Tooltip title="Your Country">
        <Box component="span" sx={{ mb: "3px" }}>
          {localeFlag(oUser.locale) || "🇬🇧"}
        </Box>
      </Tooltip>

      <Tooltip title="Your language locale">
        <Typography
          sx={{
            fontSize: "0.9rem",
            fontWeight: 600,
            color: "rgba(0,0,0,0.75)",
            whiteSpace: "nowrap",
          }}
        >
          {localeLabel(oUser.locale)}
        </Typography>
      </Tooltip>

      <Tooltip title="Edit country / evaluation language">
        <IconButton
          size="small"
          sx={{
            color: "rgba(0,0,0,0.55)",
            "&:hover": { color: "rgba(19,130,117,1)" },
          }}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  ) : null;

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        {vMode != 'PROCESSING' &&
          <>
            <Grid container mt={0}>
              <Grid item xs={12}>
                <Box display="flex" flexDirection="row" alignItems="center">
                  <Box flex="1">
                    {!isEnhancedTranscription && scanComplete && (msgTextOld == '') &&
                      <Button sx={{ textTransform: 'none', fontWeight: 'bold' }}
                        //sx={{backgroundColor:'rgb(99, 136, 137)', ":hover":{backgroundColor:'rgb(157, 188, 152)'}}} 
                        onClick={onScanAgain} color="info" variant="text">{'Try Enhanced Transcription?'}</Button>
                    }
                    {scanComplete && (msgTextOld != '') &&
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Typography>Original</Typography>
                        <AntSwitch checked={useEnhanced} onChange={onUseEnhancedChange} inputProps={{ 'aria-label': 'ant design' }} />
                        <Typography>Enhanced</Typography>
                      </Stack>
                    }
                    {savingDraft && (
                      <Box>
                        Saving ..
                      </Box>
                    )}
                  </Box>
                </Box>
                <Box sx={{ width: "100%" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    width: "100%",
                    flexWrap: isMobile ? "wrap" : "nowrap",
                  }}
                >
                    {/* Left actions */}
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        flexWrap: "wrap",
                        minWidth: 0,
                        flex: isMobile ? "1 1 100%" : "1 1 auto",
                      }}
                    >
                      <Button
                        id="scan-essay-btn"
                        sx={{ mr: 1 }}
                        className="app-btn-bg"
                        onClick={onScan}
                        color="info"
                        variant="contained"
                      >
                        SCAN ESSAY
                      </Button>
                      {!parentEssay && (
                        <Button
                          id="select-question-btn"
                          className="app-btn-bg"
                          onClick={handleOpenQuestionDialog}
                          color="info"
                          variant="contained"
                        >
                          SELECT QUESTION
                        </Button>
                      )}
                    </Box>
                    {/* Right / wrapped locale */}
                    {LocaleCapsule && (
                      <Box
                        sx={{
                          ml: isMobile ? 0 : "auto",
                          width: isMobile ? "100%" : "auto",
                          display: "flex",
                          justifyContent: isMobile ? "center" : "flex-end",
                          flex: "0 0 auto",
                        }}
                      >
                        {LocaleCapsule}
                      </Box>
                    )}
                </Box>
                  {question.questionId != null &&
                  <Card variant="outlined" sx={{ position: 'relative', padding:1.5, marginRight:0, borderRadius:'20px', marginTop:'1rem', fontSize:'18px'}}>
                    { !parentEssay && 
                      <IconButton 
                        sx={{ 
                          position: 'absolute',
                          top: 2,
                          right: 2,
                          // margin: '10px',
                          color:"rgba(19,130,117,1)",  
                          zIndex: 2
                        }} 
                        onClick={handleClearQuestion}
                        justifyItem="right">
                        <CloseIcon/>
                      </IconButton>
                    }
                    <div style={{marginBottom:'8px'}}>Selected Question</div>
                    <div> { <EssayViewQuestion question={question} isForm={true} />} </div>
                  </Card>
                  } 
              </Box>
                <Box display="flex" flexDirection="row" alignItems="center">
                  <Box flex="1" textAlign="center" color={'red'} fontWeight={'bold'}>
                    {!formValid &&
                      <div>
                        {formMsgError}
                      </div>
                    }
                  </Box>
                </Box>
                <Box backgroundColor={'yellow'} display={'flex'} justifyContent={'right'} >
                  <Box pt={0} backgroundColor={'red'}>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sx={{ mb: 1 }}>
                {titleError && (
                  <Box sx={{display: 'flex', justifyContent: 'center'}}>
                <Box
                  sx={{
                    display: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255, 193, 7, 0.15)', // warning tint
                    border: '1px solid #FFC107',
                    borderRadius: '8px',
                    padding: '8px 12px',
                    fontSize: '0.9rem',
                    fontWeight: 500,
                    marginBottom: '8px'
                  }}
                >
                  <span style={{ marginRight: '6px' }}>⚠</span>
                  <span>Please give your essay a proper title. This affects your score.</span>
                </Box>
                </Box>
              )}
              </Grid>
              <Grid item xs={12} sm={12}
                sx={{
                  backgroundColor: '#fff', borderRadius: '20px', border: '1px solid rgba(0, 0, 0, 0.12)',
                  //overflowY:'hidden', 
                  '&::-webkit-scrollbar': { width: '6px', },
                  '&::-webkit-scrollbar-track': { background: '#f1f1f1' },
                  '&::-webkit-scrollbar-thumb': { background: '#888', borderRadius: '4px', },
                  '&::-webkit-scrollbar-thumb:hover': { background: '#555' },
                }}>
                <Card variant="outlined"
                  sx={{
                    padding: 1.5, marginRight: 0, border: 'none', overflowY: 'auto', borderRadius: '20px',
                    '&::-webkit-scrollbar': { width: '6px', },
                    '&::-webkit-scrollbar-track': { background: '#f1f1f1' },
                    '&::-webkit-scrollbar-thumb': { background: '#888', borderRadius: '4px', },
                    '&::-webkit-scrollbar-thumb:hover': { background: '#555' },
                  }}>
                  <Grid item xs={12} mb={1} mt={1}>
                    <Box sx={{ fontWeight: 'bold', textAlign: 'center', paddingLeft: '10px', paddingRight: '10px' }}>
                      <TextField
                      id="essay-title-input"
                      onChange={checkTitle}
                        inputRef={txtName}
                        //value={essayTitle}
                        error={!txtNameOK} label="" variant="standard" fullWidth
                        // fontFamily: "Playpen Sans", fontSize:'2rem', textAlign:'right', 
                        sx={{ "& fieldset": { border: 'none' } }}
                        inputProps={{
                          //disableUnderline:true, 
                          style: {
                            fontFamily: "Playpen Sans", fontSize: '2rem',
                            textAlign: 'center', //disableUnderline: true
                            // backgroundColor: highlight ? 'yellow' : 'transparent'
                          }
                        }}
                        placeholder={titlePlaceHolder}
                        spellCheck="false" autoComplete="off" autoCorrect="off" autoCapitalize="off"
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        fontSize: '1.3rem', lineHeight: '35px', fontFamily: "'Playpen Sans', cursive", height: '30rem',
                        border: '0 solid #efefef', borderRadius: '6px', padding: '5px', marginLeft: '5px',
                      }}>
                      {showTypewriter && (

                        <Typewriter id="essay-body-input" onClick={typewirterClick}
                          text="  Once upon a time in a beautiful green park, there lived a small, friendly squirrel named Sammy. Sammy loved playing hide and seek with his friends, but he had a big dream. He wanted to find the Golden Acorn, a legendary nut said to be hidden somewhere in the park. Every day, Sammy would go on an adventure, looking under leaves and climbing tall trees, hoping to find the acorn. One sunny day, while searching near the old oak tree, Sammy met a wise old owl. The owl told Sammy that the Golden Acorn was not just a nut, but a symbol of bravery and determination. Encouraged by the owl's words, Sammy didn't give up. He continued his search with even more enthusiasm. Finally, after many days of looking, Sammy found the Golden Acorn. It was more beautiful than he had imagined. But the most important thing he found was not the acorn, but the courage and persistence he had within himself all along. Sammy learned that with determination and a positive attitude, you can achieve your dreams. And that was the greatest treasure of all." />
                      )}
                      {!showTypewriter && (
                        <div className="divBody"
                          id="essay-body-input" 
                          data-text={bodyPlaceHolder}
                          ref={divRef}
                          spellCheck="false"
                          onInput={msgTextChangeV2}
                          onPaste={msgTextPaste}
                          contentEditable="true"
                          dangerouslySetInnerHTML={{ __html: msgText }}
                          style={{
                            fontSize: '1.3rem', fontFamily: "'Playpen Sans', cursive", lineHeight: '35px',
                            background: 'linear-gradient(to bottom, white 34px, #00b0d7 1px)', backgroundSize: '100% 35px',
                            minHeight: '25rem',
                            direction: 'ltr', // Ensure left-to-right text direction
                            width: '100%', textAlign: 'left', padding: '0', border: 'none', outline: 'none', overflow: 'auto',
                          }}
                        >
                        </div>
                      )}

                      <textarea
                        onChange={msgTextChange}
                        onPaste={msgTextPaste}
                        value={msgText}
                        rows={bodyRows}
                        style={{
                          display: 'none', // Hide the textarea
                          fontSize: '1.3rem', fontFamily: "'Playpen Sans', cursive", lineHeight: '35px',
                          background: 'linear-gradient(to bottom, white 34px, #00b0d7 1px)', backgroundSize: '100% 35px',
                          width: '100%', textAlign: 'left', padding: '0', border: 'none', outline: 'none', overflow: 'auto',
                          //background:'none'
                        }}
                        spellCheck="false" autoComplete="off" autoCorrect="off" autoCapitalize="off"
                      >
                      </textarea>
                    </Box>
                  </Grid>
                </Card>
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ mb: 1 }}>
                  <span style={{fontWeight: 'bold'}}>{charCount}</span> / {maxWordCount} Words
                </Box>
              </Grid>
              <Grid item xs={3}>
                <Box display="flex" justifyContent="flex-end" alignItems='center' flexDirection='column'>
              
                </Box>
              </Grid>
            </Grid>
            <Grid item>
             
            </Grid>
            {titleError && (
            <Grid container pt={0.5} justifyContent="space-between">
              <Grid item></Grid>
              <Grid item></Grid>
                <Box
                  sx={{
                    display: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255, 193, 7, 0.15)', // warning tint
                    border: '1px solid #FFC107',
                    borderRadius: '8px',
                    padding: '8px 12px',
                    fontSize: '0.9rem',
                    fontWeight: 500,
                    marginBottom: '8px'
                  }}
                >
                  <span style={{ marginRight: '6px' }}>⚠</span>
                  <span>Please give your essay a proper title. This affects your score.</span>
                </Box>
                </Grid>
              )}
            <Grid container pt={0.5} justifyContent="flex-end" spacing={1}>
              {draftId && (
                <Grid item>
                  <Button
                    variant="outlined"
                    sx={{
                      color: 'rgba(19,130,117,1)',
                      borderColor: 'rgba(19,130,117,1)',
                      '&:hover': {
                        backgroundColor: 'rgba(19,130,117,0.08)',
                        borderColor: 'rgba(19,130,117,1)',
                      },
                    }}
                    onClick={onDiscard}
                  >
                    {'DISCARD'}
                  </Button>
                </Grid>
              )}
              <Grid item>
                <Button
                  className="app-btn-bg"
                  id="submit-btn" 
                  //</Grid>sx={{backgroundColor:'rgb(99, 136, 137)', ":hover":{backgroundColor:'rgb(157, 188, 152)'}}} 
                  onClick={onSubmit} color="info" variant="contained">{submitOverride ? 'SUBMIT ANYWAY' : (isEdit ? 'UPDATE' : 'SUBMIT')}</Button>
              </Grid>
            </Grid>
            <ScanPopup isClear={false} isOpen={isPopupOpen} isCropped={isCropped} onClose={handleClosePopup}
              onScanComplete={handleScanComplete} onCamOpen={onCamOpen} ref={refPopScan} isSa={isSa}
              scanAgain={scanAgainStart}
            />
            <PopScanAgain
              open={scanAgain}
              onCancel={onScanAgainCancel}
              onStart={onScanAgainStart}
            />
            <ScanCam isClear={false} isOpen={isScanCamOpen} onClose={onCamClose} onScanComplete={handleScanComplete} onCamCapture={onCamCapture} />
          </>
        }
        {(vMode == 'PROCESSING' || startProcessing) && 
        <EssaySubmitStatus essayId={newEssayId} essayStatusCheckDone={essayStatusCheckDone}/>
        }
      </Box>
      <PopQuestion
        open={isPopupQuestionOpen}
        onClose={popQuestionClose}
        onSubmit={popQuestionSubmit}
        grade={grade}
      />
    </>
  );
}